import { generateStripeState } from '../helper'

const options = {
  api: {
    get: ({ id }) => `/api/stripe/invoiceItem/${id}`,
    list: () => `/api/stripe/invoiceItems`,
    delete: ({ id }) => `/api/stripe/invoiceItem/${id}`,
    update: ({ id }) => `/api/stripe/invoiceItem/${id}`,
    create: () => `/api/stripe/invoiceItem`
  },
  state: {
    collectionName: 'invoiceItems'
  },
  getters: {
    getPagination: 'getInvoiceItemPagination',
    getCollection: 'getInvoiceItems'
  },
  actions: {
    get: 'getInvoiceItem',
    list: 'listInvoiceItems',
    delete: 'deleteInvoiceItem',
    update: 'updateInvoiceItem',
    create: 'createInvoiceItem'
  },
  mutationKey: 'INVOICE_ITEM',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions
  },
  mutations:{
    ...stripeMutations
  }
}
